interface JobDetailsPagePropsInput {
  jobDetails?: any;
  isPremiumUser?: any;
  isLoggedIn?: any;
  themeType?: any;
  isFreeJob?: any;
  deviceType?: any;
  breadCrumbProps?: any;
  isJobDetailsPage?: any;
  handleBackBtn?: any;
  localization?: any;
  saveJobState?: any;
  isExperiment?: any;
  breadCrumbNameWithCategories?: any;
  basePathRewrite?: any;
  isSecondaryModalPopup?: any;
  handleApplyJob?: any;
  trackJobSearchResult?: any;
  cetgoriesCount?: any;
  hiring_count?: any;
  similarJobs?: any;
  userInteractExpId?: boolean;
  isCategoryPageExp?: boolean;
  assetUrl?: any;
  faqData?: any;
  isJobDetailsFaqJEnabled?: boolean;
  faqTitle?: string;
}
export default function jobDetailsPageProps(props: JobDetailsPagePropsInput) {
  const {
    jobDetails,
    isPremiumUser,
    isLoggedIn,
    themeType,
    isFreeJob,
    deviceType,
    breadCrumbProps,
    isJobDetailsPage,
    handleBackBtn,
    localization,
    saveJobState,
    isExperiment,
    breadCrumbNameWithCategories,
    basePathRewrite,
    isSecondaryModalPopup,
    handleApplyJob,
    trackJobSearchResult,
    cetgoriesCount,
    hiring_count,
    similarJobs,
    userInteractExpId,
    isCategoryPageExp,
    assetUrl,
    isJobDetailsFaqJEnabled,
    faqData,
    faqTitle,
  } = props;
  return {
    jobDetails,
    isPremiumUser,
    isLoggedIn,
    themeType,
    isFreeJob,
    deviceType,
    breadCrumbProps,
    isJobDetailsPage,
    handleBackBtn,
    localization,
    saveJobState,
    isExperiment,
    breadCrumbNameWithCategories,
    basePathRewrite,
    isSecondaryModalPopup,
    handleApplyJob,
    trackJobSearchResult,
    cetgoriesCount,
    hiring_count,
    similarJobs,
    userInteractExpId,
    isCategoryPageExp,
    assetUrl,
    faqData,
    isJobDetailsFaqJEnabled,
    faqTitle,
  };
}
